import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { TuiTextfieldControllerModule, TuiInputModule } from '@taiga-ui/legacy';
import {
  TuiDataList,
  TuiLoader,
  TuiScrollbar,
  TuiScrollable,
  TuiGroup,
  TuiDropdown,
  TuiIcon,
  TuiButton,
  TuiFallbackSrcPipe,
  TuiInitialsPipe,
  TuiAutoColorPipe,
  TuiTextfield,
  TuiSelectLike,
} from '@taiga-ui/core';
import {
  TuiDataListWrapper,
  TuiAccordion,
  TuiBadge,
  TuiCheckbox,
  TuiAvatar,
  TuiChevron,
  TuiSelect,
  TuiInputChip,
  TuiMultiSelect,
} from '@taiga-ui/kit';
import { TuiActiveZone, TuiLet, TuiObscured } from '@taiga-ui/cdk';
import { TuiDropdownMobile } from '@taiga-ui/addon-mobile';
import { SharedModule } from '@src/app/shared';
import { ComponentsModule } from '@src/app/components';

import {
  SearchUsersDialogComponent,
  SearchUsersInputComponent,
  RenderUserRowComponent,
  UsersTagsComponent,
  SearchUsersFiltersComponent,
  FilterAccordionContentComponent,
  FilterAccordionTitleComponent,
  SelectAllLinkComponent,
  FilterAccordionContentFieldsComponent,
} from './components';

@NgModule({
  declarations: [
    SearchUsersDialogComponent,
    SearchUsersInputComponent,
    RenderUserRowComponent,
    UsersTagsComponent,
    SearchUsersFiltersComponent,
    FilterAccordionContentComponent,
    FilterAccordionTitleComponent,
    SelectAllLinkComponent,
    FilterAccordionContentFieldsComponent,
  ],
  imports: [
    CommonModule,
    TuiButton,
    TuiTextfieldControllerModule,
    TuiLet,
    ...TuiDataList,
    FormsModule,
    TuiIcon,
    TuiGroup,
    TuiAvatar,
    SharedModule,
    ComponentsModule,
    ...TuiDropdown,
    ...TuiDataListWrapper,
    TuiLoader,
    TuiCheckbox,
    TuiScrollbar,
    TuiScrollable,
    TuiBadge,
    ...TuiAccordion,
    TuiInputModule,
    TuiActiveZone,
    TuiObscured,
    TuiDropdownMobile,
    TuiFallbackSrcPipe,
    TuiInitialsPipe,
    TuiAutoColorPipe,
    ...TuiTextfield,
    TuiChevron,
    ...TuiSelect,
    ...TuiInputChip,
    ...TuiMultiSelect,
    TuiSelectLike,
  ],
  exports: [SearchUsersInputComponent],
})
export class SearchUsersModule {}
